const toggleMap = {
    productWrap: document.getElementById('categoryCol'),
    mapWrap: document.getElementById('categoryMap'),
    

    init() {
        this.addListener();
    },

    addListener() {
        window.addEventListener('mapEvent', (event) => {           
            const customEvent = event as CustomEvent<boolean>;
            if(customEvent.detail){
                this.productWrap?.classList.add('active')
                this.mapWrap?.classList.add('active')
            }else{
                this.productWrap?.classList.remove('active')
                this.mapWrap?.classList.remove('active')
            }
           
            console.log(customEvent.detail); 
          });

    }


}

export default toggleMap;